'use client';

import {PaginationResponsiveConfig} from '@shared/NewPagination';
import {ComponentProps, memo} from 'react';

import {AppsResponse} from '@web-catalog/types';

import {useFilters} from '@web-catalog/hooks/useFilters';

import {AppsWithPagination} from './AppsWithPagination';
import {AppsList, Filters, NotFoundFiltered} from './parts';

type Props = {
  appsResponse?: AppsResponse;
  pageNumber: number;
  listName: string;
  logCustomAnalyticsOnClick?: ComponentProps<
    typeof AppsList
  >['logCustomAnalyticsOnClick'];
  allowAds?: boolean;
  className?: string;
  listClassName?: string;
  newPaginationConfig?: PaginationResponsiveConfig;
  basePath: string;
  searchParams?: URLSearchParams;
  isFiltersEnabled?: boolean;
};

export const AppsWithPaginationAndFilters = memo<Props>(
  ({isFiltersEnabled, ...rest}) => {
    const {getFullValue, filterBy} = useFilters();
    const filterString = filterBy.get();

    return (
      <>
        {isFiltersEnabled && <Filters />}
        <AppsWithPagination
          {...rest}
          searchParams={new URLSearchParams(getFullValue())}
          emptyView={<NotFoundFiltered filter={filterString} />}
        />
      </>
    );
  },
);

AppsWithPagination.displayName = 'AppsWithPagination';
